<ng-content></ng-content>
<div class="bar-hover-container">
    <div
        #tooltip
        class="bar-hover-tooltip"
    >
        <div class="tooltip-inner">
            <ng-container
                *ngTemplateOutlet="
                    hoverTooltipContent;
                    context: { data: hoverTooltipData }
                "
            >
            </ng-container>
        </div>
    </div>
</div>
